<template>
  <v-dialog
    v-model="dialog"
    width="auto"
  >
    <v-card
      min-width="300"
    >
      <div class="text-xs tracking-widest m-8">SELECT DURATION</div>
      <div class="text-2xl font-medium">{{ formattedDuration }}</div>
      <v-slider
      v-model="value"
      :color="color"
      :max="12"
      :min="4"
      :step="0.25"
      >
        <template v-slot:prepend>
          <v-btn
            :color="color"
            icon="mdi-minus"
            size="small"
            variant="text"
            @click="decrement"
          ></v-btn>
        </template>

        <template v-slot:append>
          <v-btn
            :color="color"
            icon="mdi-plus"
            size="small"
            variant="text"
            @click="increment"
          ></v-btn>
        </template>
      </v-slider>
    </v-card>
  </v-dialog>
</template>

<script>
import { formatDuration } from '@/helpers/time'

export default {
  name: 'DurationSelector',
  components: {
  },
  props: {
    duration: Number,
    showSelector: Boolean,
  },
  emits: [
    'update:duration',
    'update:showSelector',
  ],
  data() {
    return {
    }
  },
  beforeMount() {
  },
  methods: {
    decrement () {
      this.value -= 0.25
    },
    increment () {
      this.value += 0.25
    },
  },
  computed: {
    value: {
      get() {
        return this.duration
      },
      set(value) {
        this.$emit('update:duration', value)
      },
    },
    dialog: {
      get() {
        return this.showSelector
      },
      set(value) {
        this.$emit('update:showSelector', value)
      },
    },
    formattedDuration() {
      return formatDuration(this.value)
    },
    color () {
      if (this.value < 7) return 'red'
      return 'green'
    },
  }
}
</script>